import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgEspacesVerts = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="espacesVerts_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>
				{
					`.prestation_cls_fill_none{fill:none;stroke:${color};stroke-miterlimit:40;stroke-width:10px}`
				}
			</style>
		</defs>
		<path
			className="prestation_cls_fill_none"
			d="M162.88 112.66c1.21-3.67 1.88-7.6 1.88-11.67 0-20.55-16.66-37.2-37.2-37.2s-37.21 16.66-37.21 37.2c0 4.08.67 8 1.88 11.67-16.32 3.94-28.45 18.63-28.45 36.16 0 11.86 5.56 22.42 14.21 29.23-8.65 6.81-14.21 17.37-14.21 29.23 0 20.55 16.66 37.2 37.2 37.2h26.58M127.56 318.9V116.93"
		/>
		<path
			className="prestation_cls_fill_none"
			d="m149.42 198.02-21.86 14.58-31.89-21.26M159.45 138.19l-31.89 21.26-31.89-21.26M297.64 318.9V116.93M329.53 191.34l-31.89 21.26-21.86-14.58M329.53 138.19l-31.89 21.26-31.89-21.26"
		/>
		<path
			className="prestation_cls_fill_none"
			d="M212.6 287.01h26.57c20.55 0 37.2-16.66 37.2-37.2 0-11.86-5.56-22.42-14.21-29.23 8.65-6.81 14.21-17.37 14.21-29.23 0-17.53-12.13-32.22-28.45-36.16 1.21-3.67 1.88-7.6 1.88-11.67 0-20.55-16.66-37.2-37.2-37.2s-37.21 16.66-37.21 37.2c0 4.08.67 8 1.88 11.67-16.32 3.94-28.45 18.63-28.45 36.16 0 11.86 5.56 22.42 14.21 29.23-8.65 6.81-14.21 17.37-14.21 29.23 0 20.55 16.66 37.2 37.2 37.2M212.6 361.42V159.45"
		/>
		<path
			className="prestation_cls_fill_none"
			d="m244.49 233.86-31.89 21.26-31.89-21.26M244.49 180.71l-31.89 21.26-31.89-21.26M243.9 123.41a37.02 37.02 0 0 1 5.9 20.1c0 4.08-.67 8-1.88 11.67 16.32 3.94 28.45 18.63 28.45 36.16 0 11.86-5.56 22.42-14.21 29.23 7.33 5.78 12.43 14.25 13.81 23.92M297.64 244.49h26.57c20.55 0 37.2-16.66 37.2-37.2 0-11.86-5.56-22.42-14.2-29.23 8.65-6.81 14.2-17.37 14.2-29.23 0-17.53-12.13-32.22-28.45-36.16 1.21-3.67 1.88-7.6 1.88-11.67 0-20.55-16.66-37.2-37.2-37.2s-37.2 16.66-37.2 37.2c0 4.08.67 8 1.88 11.67"
		/>
	</svg>
)
export default SvgEspacesVerts
